import gql from 'graphql-tag'

import { PublicExpoDeleteRegistrationMutation } from '../../../types/api'

export const deleteRegistration = {
  mutation: gql`
    mutation publicExpoDeleteRegistration {
      publicExpoDeleteRegistration
    }
  `,
  transformer: (response: PublicExpoDeleteRegistrationMutation) => {
    return response.publicExpoDeleteRegistration
  },
}
